// RBAC 权限指令 v-permission
// 用法: v-permission="'system:user:add'" 或 v-permission="['system:user:add','system:user:edit']"

const checkPermission = (el, binding) => {
  const { value } = binding
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const roles = JSON.parse(localStorage.getItem('roles') || '[]')

  // 超级管理员拥有所有权限
  if (roles.includes('admin') || roles.includes('superadmin')) return

  if (!value) return

  const requiredPerms = Array.isArray(value) ? value : [value]
  const hasPermission = requiredPerms.some(perm => permissions.includes(perm) || permissions.includes('*:*:*'))

  if (!hasPermission) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default {
  mounted(el, binding) {
    checkPermission(el, binding)
  },
  updated(el, binding) {
    checkPermission(el, binding)
  }
}

// 函数式权限检查（用于js逻辑中）
export function hasPermission(perm) {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const roles = JSON.parse(localStorage.getItem('roles') || '[]')
  if (roles.includes('admin') || roles.includes('superadmin')) return true
  if (!perm) return true
  const perms = Array.isArray(perm) ? perm : [perm]
  return perms.some(p => permissions.includes(p) || permissions.includes('*:*:*'))
}

// 函数式角色检查
export function hasRole(role) {
  const roles = JSON.parse(localStorage.getItem('roles') || '[]')
  if (!role) return true
  const required = Array.isArray(role) ? role : [role]
  return required.some(r => roles.includes(r))
}
